export default (window as any).__ENV__;
